// extracted by mini-css-extract-plugin
export default {"noResults":"_26bd5cd9"};